
import {Injectable} from '@angular/core';
import {MsalBroadcastService, MsalService} from '@azure/msal-angular';
import {PopupRequest, AuthenticationResult, InteractionRequiredAuthError, PromptValue, EventMessage, EventType, RedirectRequest} from '@azure/msal-browser'
import {Observable, Subject, takeUntil} from "rxjs";
import {AppConfigService} from "../app-config.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: 'root',
})
export class MsalAuthService {

    private jwt: string = null;
    private readonly _destroying$ = new Subject<void>();
    private _hasActiveAccount: Subject<boolean> = new Subject();
    public hasActiveAccount$: Observable<boolean> = this._hasActiveAccount.asObservable();
    public getHasActiveAccount(): boolean {
        return this.msal.instance.getActiveAccount() != null;
    }
    constructor(
        private msal: MsalService,
        // private msalBroadcast: MsalBroadcastService,
        private config: AppConfigService
    ) {
        let me = this;
        // this.msalBroadcast.msalSubject$
        //     .pipe(
        //         // filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
        //         takeUntil(this._destroying$)
        //     )
        //     .subscribe({
        //         next: (msg:EventMessage) => {
        //             // console.log("MSAL Subject " + msg.eventType + ' ; ', msg);
        //             // if ( msg.eventType === EventType.LOGIN_SUCCESS ) {
        //             //     me._hasActiveAccount.next(true); //me.hasActiveAccount.set(true);
        //             // }
        //             // if ( msg.eventType === EventType.ACTIVE_ACCOUNT_CHANGED && me._hasActiveAccount ) {
        //             //     me._hasActiveAccount.next(true); //me.hasActiveAccount.set(true);
        //             // }
        //             // if ( msg.eventType === EventType.LOGOUT_SUCCESS ) {
        //             //     me._hasActiveAccount.next(false); //me.hasActiveAccount.set(false);
        //             // }
        //         }
        //     })
        // ;
        // this.msalBroadcast.inProgress$
        //     .pipe(
        //         // filter((msg: EventMessage) => msg.eventType === EventType. || msg.eventType === EventType.ACCOUNT_REMOVED),
        //         takeUntil(this._destroying$)
        //     )
        //     .subscribe({
        //         next: (resp:any) => {
        //             console.log("MSAL Progress " + resp.eventType + ' ; ', resp);
        //         }
        //     })
        // ;
        this.msal.handleRedirectObservable().pipe(takeUntilDestroyed()).subscribe({
            next: (result: AuthenticationResult) => {
                // console.log("handleRedirectObservable: ", result);
                // Perform actions related to user accounts here
                const accounts = this.msal.instance.getAllAccounts();
                if (accounts.length > 0) {
                    let account = accounts[0];
                    this.msal.instance.setActiveAccount(account);
                    // console.log("Sending TRUE");
                    me._hasActiveAccount.next(true); //this.hasActiveAccount.set(true);
                } else {
                    // console.log( "logginout");
                    me._hasActiveAccount.next(false); //this.hasActiveAccount.set(false);
                }
            },
            error: (error) => {
                console.log(error);
            }
        });

    }
    ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }
    public login() {
        const redirectRequest: RedirectRequest = {
            scopes: ["Calendars.ReadBasic"]
        };
        this.msal.loginRedirect(redirectRequest);
    }
    public logout() {
        console.log( "MSAL Logout" );
        this.msal.logoutPopup();
    }

    getActiveAccount() {
        return this.msal.instance.getActiveAccount() ?? this.msal.instance.getAllAccounts()[0];
    }
    async getAccessToken(scopes: string[]): Promise<string> {
        // Ensure we have an account and pass it explicitly
        let account = this.msal.instance.getActiveAccount();
        if (!account) {
            const accounts = this.msal.instance.getAllAccounts();
            if (accounts.length > 0) {
                account = accounts[0];
                this.msal.instance.setActiveAccount(account);
            } else {
                // Not signed in → do login first
                // await this.msal.loginPopup({ scopes: ['Calendars.ReadBasic'], prompt: 'select_account' });
                // account = this.msal.instance.getActiveAccount() ?? this.msal.instance.getAllAccounts()[0];
                // console.log( "Active Account 2: ", account );
            }
        } else {
            // console.log( "Has Active Account" );
        }
        // SILENT first
        try {
            // console.log( "Attempt Silent Token" );
            const result = await this.msal.instance.acquireTokenSilent({ account, scopes });
            return result.accessToken;
        } catch (e) {
            // console.log( "Silent Token Failed " );
            // If interaction is required, do POPUP with a well-formed request (scopes present)
            throw e;
        }
    }
    /* ******************************************** */
    /* CALENDAR FUNCTIONS */

    async getMyEvents( startDate: string, endDate: string ) {
        if ( this.jwt == null ) {
            this.jwt = await this.getAccessToken( ['Calendars.ReadBasic'] );
        }
        // /me/calendarView?startDateTime=2026-02-04T00:00:00-08:00&endDateTime=2026-02-05T00:00:00-08:00
        const token = this.jwt; // Replace with your actual token
        // const url = this.config.getGraphAPI() + '/me/events?$top=25';
        const url = this.config.getGraphAPI() + `/me/calendarView?startDateTime=${startDate}&endDateTime=${endDate}`;
        let events = [];
        return await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`, // The important part
                'Content-Type': 'application/json' // Add other headers as needed
            }
        })
            .then(response => response.json())
            .then((data) => { return data['value']; })
            .catch(error => console.error('Error:', error));
    }

    /* ******************************************** */
    /* MAIL FUNCTIONS */
    async getMailUnreadCount() {
        // /mailFolders/Inbox?$select=unreadItemCount
        // /me/mailFolders/Inbox/messages?$filter=isRead eq false$count=true
        if ( this.jwt == null ) {
            this.jwt = await this.getAccessToken( ['Mail.Read'] );
        }
        const token = this.jwt; // Replace with your actual token
        const url = this.config.getGraphAPI() + '/me/mailFolders/Inbox?$select=unreadItemCount';
        return await fetch(url, {
            method: 'GET', // Or 'POST', 'PUT', etc.
            headers: {
                'Authorization': `Bearer ${token}`, // The important part
                'Content-Type': 'application/json' // Add other headers as needed
            }
        })
            .then(response => response.json())
            .then((data) => { return data['unreadItemCount']; } )
            .catch(error => console.error('Error:', error));

    }
}
